import React from 'react';
import {
  Navbar,
  NavbarIcon,
  NavbarControls,
  NavbarLink,
  Button,
  Link,
} from 'react-ittsu/components';
import { Main, Header, Container, Footer } from 'react-ittsu/layout';

import { translate as t } from '~/utils/translation';
import { openIntercom } from '~/pods/order/utils';
import RouteContainer from '~/components/RouteContainer';
import FooterContent from '~/containers/FooterContent';

import styles from 'styles/components/error-page';
import logo from 'images/logo.svg';


// Opens the Intercom chat (CriticalError, an unknown transaction link)
export const contactUsAction = () => ({
  label: t('routes.critical_error.contact_us'),
  onClick: openIntercom,
});


// Full page for routes/CriticalError, NotFound, InvalidLink and the payment return page: navbar
// with a home link, an optional illustration, a title and subtitle, and one way forward.
// - `action`: { label, onClick } or { label, href }
// - `titleAs`: the title's element ('div' by default; InvalidLink makes it the page's h1)
// - `wrapAction`: put the button in a styled wrapper (true by default; NotFound renders it bare)
// - `modifier`: a class from styles/components/error-page ('notFound', 'invalidLink',
//   'paymentReturn') for
//   page-specific styling only
const ErrorPage = ({ image, title, subtitle, action, titleAs: Title = 'div', wrapAction = true, modifier }) => {
  const button = action != null ? (
    <Button category="primary" href={action.href} onClick={action.onClick}>
      {action.label}
    </Button>
  ) : null;
  return (
    <div className={modifier != null ? `${styles.errorPage} ${styles[modifier]}` : styles.errorPage}>
      <Header>
        <Navbar withContainer>
          <Link href="/">
            <NavbarIcon image={logo} />
          </Link>
          <NavbarControls>
            <NavbarLink><Link underlined="none" href="/">{t('routes.not_found.back_home')}</Link></NavbarLink>
          </NavbarControls>
        </Navbar>
      </Header>
      <Main>
        <RouteContainer>
          <Container style={{ height: '100%' }}>
            <div className={styles.container}>
              {image != null ? <img src={image} className={styles.backgroundImage} alt="" /> : null}
              <div className={styles.content}>
                <Title className={styles.title}>{title}</Title>
                <div className={styles.subtitle}>{subtitle}</div>
              </div>
              {button != null && wrapAction ? <div className={styles.action}>{button}</div> : button}
            </div>
          </Container>
        </RouteContainer>
      </Main>
      <Footer>
        <FooterContent />
      </Footer>
    </div>
  );
};


export default ErrorPage;
